import React from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

interface BlurToggleButtonProps {
  blurred: boolean;
  onToggle: () => void;
}

// Progress photos and measurement attachments are blurred by default, so the
// dashboard can be open in a shared space. Both galleries use this control.
const BlurToggleButton: React.FC<BlurToggleButtonProps> = ({
  blurred,
  onToggle,
}) => (
  <button
    onClick={onToggle}
    className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
    title={blurred ? "Show images" : "Blur images"}
  >
    {blurred ? (
      <>
        <MdVisibility className="h-5 w-5" />
        <span className="hidden sm:inline">Show</span>
      </>
    ) : (
      <>
        <MdVisibilityOff className="h-5 w-5" />
        <span className="hidden sm:inline">Blur</span>
      </>
    )}
  </button>
);

export default BlurToggleButton;
